import Joi from 'joi';

import { IProductCardWithTextSectionProps } from './models';

const stringRequired = Joi.string().required();
const stringOptional = Joi.string().optional();
const uriRequired = Joi.string().uri().required();
const imgSchema = {
  url: uriRequired,
  filename: Joi.string().required(),
};
const requiredImageSchema = Joi.object(imgSchema).required();

export const productCardWithTextSectionSchema = Joi.object<IProductCardWithTextSectionProps>({
  text: stringRequired,
  productName: stringRequired,
  image: requiredImageSchema,
  imageAlt: stringRequired,
  cardStyle: stringRequired,
  buttonLink: stringOptional,
  buttonText: stringOptional,
  iconOne: requiredImageSchema,
  iconOneAlt: stringRequired,
  iconOneText: stringRequired,
  iconTwo: requiredImageSchema,
  iconTwoAlt: stringRequired,
  iconTwoText: stringRequired,
  iconThree: requiredImageSchema,
  iconThreeAlt: stringRequired,
  iconThreeText: stringRequired,
}).options({ stripUnknown: true });
